import angular from 'angular';

angular.module('cxTable').directive('cxStickyRowOffset', [
  function() {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        var table = element[0];
        if (typeof ResizeObserver === 'undefined') return;

        // Rows of this class pin below the grid header while their tbody is in view.
        var stickyRowSelector = attrs.cxStickyRowOffset
          ? 'tbody > tr.' + attrs.cxStickyRowOffset
          : null;
        var pinTop = NaN;

        // A sticky cell is constrained by the table and not by its tbody, so a pinned row
        // would stay pinned after its own tbody has scrolled past the pin line: release it.
        var releaseRowsScrolledPast = function() {
          if (!stickyRowSelector || isNaN(pinTop)) return;

          [].forEach.call(table.querySelectorAll(stickyRowSelector), function(row) {
            var tbodyBottom = row.parentElement.getBoundingClientRect().bottom;
            var scrolledPast = tbodyBottom < pinTop + row.getBoundingClientRect().height;
            row.classList.toggle('sticky-row-released', scrolledPast);
          });
        };

        // Rows that pin below the grid header read their offset from this property:
        // the offset is the header's own sticky offset plus its height, and that height
        // is not a constant because the column titles wrap at narrower window widths.
        var update = function() {
          var thead = table.querySelector('thead');
          var stickyHeader = thead && thead.querySelector('th.sticky-header');
          if (!stickyHeader || !thead.offsetHeight) return; // keep the stylesheet's fallback

          var headerOffset = parseFloat(getComputedStyle(stickyHeader).top);
          if (isNaN(headerOffset)) return;

          pinTop = headerOffset + thead.offsetHeight;
          table.style.setProperty('--sticky-row-top', pinTop + 'px');
          releaseRowsScrolledPast();
        };

        // Only runs when the table's box actually changes: rows being loaded and the window
        // being resized both re-wrap the header. Observing the thead does not report.
        var observer = new ResizeObserver(update);
        observer.observe(table);
        update();
        window.addEventListener('scroll', releaseRowsScrolledPast, { passive: true });

        // Bound to the element, not the scope: this table is recompiled by cx-table.
        element.on('$destroy', function() {
          observer.disconnect();
          window.removeEventListener('scroll', releaseRowsScrolledPast);
        });
      },
    };
  },
]);
